/* import __COLOCATED_TEMPLATE__ from './tab-pane.hbs'; */
import Component from '@ember/component';

export default class TabPane extends Component {
    tagName = '';
    errorList = [];
    error = '';
}
